import EdTableEditor from './src/EdTableEditor.vue';

/* istanbul ignore next */
EdTableEditor.install = function (Vue) {
  Vue.component(EdTableEditor.name, EdTableEditor)
}

export default EdTableEditor;
